import { useEffect, useState, type FormEvent } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

const NAV_ITEMS = [
  { label: "首页", to: "/" },
  { label: "电影", to: "/category/movie" },
  { label: "电视剧", to: "/category/tv" },
  { label: "综艺", to: "/category/variety" },
  { label: "资讯", to: "/news" },
];

export default function Navbar() {
  const navigate = useNavigate();
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);
  const [keyword, setKeyword] = useState("");

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  const submitSearch = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const q = keyword.trim();
    if (!q) return;
    navigate(`/search?q=${encodeURIComponent(q)}`);
    setKeyword("");
    setMenuOpen(false);
  };

  const isActive = (to: string) =>
    to === "/" ? location.pathname === "/" : location.pathname.startsWith(to);

  return (
    <header className="sticky top-0 z-50 border-b border-background-200 bg-background-50/95 backdrop-blur">
      <div className="mx-auto flex h-16 w-full items-center gap-4 px-4 md:px-6">
        <Link to="/" className="flex shrink-0 items-center gap-2">
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-600 text-background-50">
            <i className="ri-movie-2-line text-xl"></i>
          </span>
          <span className="font-heading text-xl font-bold tracking-tight text-foreground-950">
            大象传媒
          </span>
        </Link>

        <nav className="hidden items-center gap-1 md:flex">
          {NAV_ITEMS.map((item) => (
            <Link
              key={item.to}
              to={item.to}
              className={`rounded-md px-3 py-2 text-sm font-medium transition-colors ${
                isActive(item.to)
                  ? "bg-primary-100 text-primary-700"
                  : "text-foreground-700 hover:bg-background-100 hover:text-primary-700"
              }`}
            >
              {item.label}
            </Link>
          ))}
        </nav>

        <form
          onSubmit={submitSearch}
          className="ml-auto hidden w-full max-w-xs items-center gap-2 rounded-md border border-background-300 bg-background-100 px-3 py-2 md:flex"
        >
          <span className="flex h-4 w-4 items-center justify-center text-foreground-500">
            <i className="ri-search-line text-base"></i>
          </span>
          <input
            value={keyword}
            onChange={(e) => setKeyword(e.target.value)}
            placeholder="搜索影视作品或资讯"
            className="w-full bg-transparent text-sm text-foreground-900 outline-none placeholder:text-foreground-500"
          />
        </form>

        <button
          type="button"
          aria-label="打开菜单"
          onClick={() => setMenuOpen((v) => !v)}
          className="ml-auto flex h-10 w-10 items-center justify-center rounded-md border border-background-300 text-foreground-800 md:hidden"
        >
          <i className={menuOpen ? "ri-close-line text-xl" : "ri-menu-line text-xl"}></i>
        </button>
      </div>

      {menuOpen && (
        <div className="border-t border-background-200 bg-background-50 px-4 py-4 md:hidden">
          <form
            onSubmit={submitSearch}
            className="mb-3 flex items-center gap-2 rounded-md border border-background-300 bg-background-100 px-3 py-2"
          >
            <span className="flex h-4 w-4 items-center justify-center text-foreground-500">
              <i className="ri-search-line text-base"></i>
            </span>
            <input
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder="搜索影视作品或资讯"
              className="w-full bg-transparent text-sm text-foreground-900 outline-none placeholder:text-foreground-500"
            />
          </form>
          <nav className="flex flex-col gap-1">
            {NAV_ITEMS.map((item) => (
              <Link
                key={item.to}
                to={item.to}
                className={`rounded-md px-3 py-3 text-sm font-medium ${
                  isActive(item.to)
                    ? "bg-primary-100 text-primary-700"
                    : "text-foreground-800 hover:bg-background-100"
                }`}
              >
                {item.label}
              </Link>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}